// Last email the visitor typed into any of our lead forms (homepage quiz,
// advisor-call modal, shortlist share bar). Used only to PREFILL later email
// asks, never to auto-submit: the value is unverified, and localStorage
// outlives whoever typed it on a shared machine, so the visitor always gets a
// look at the address before we email anything to it.
//
// The self-contained quiz pages (_hero_quiz.html.erb and
// recommendations/landing.html.erb run inline scripts outside the Vite graph)
// write the same key by hand — keep the shape in sync with rememberEmail().
const KNOWN_EMAIL_KEY = 'tbKnownEmail';
const QUIZ_KEY = 'tbRecoQuiz';
const MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000; // matches the quiz-resume window

export function rememberEmail(email) {
  const value = (email || '').trim().toLowerCase();
  if (!value) return;
  try {
    localStorage.setItem(KNOWN_EMAIL_KEY, JSON.stringify({ email: value, savedAt: Date.now() }));
  } catch (e) {
    // Private mode / full storage — later forms just start blank.
  }
}

export function knownEmail() {
  const fresh = (raw) => {
    if (!raw || !raw.savedAt || Date.now() - raw.savedAt > MAX_AGE_MS) return '';
    return (raw.email || '').trim();
  };
  try {
    const saved = fresh(JSON.parse(localStorage.getItem(KNOWN_EMAIL_KEY)));
    if (saved) return saved;
  } catch (e) { /* fall through to the quiz copy */ }
  // Visitors who gave their (optional) email to the homepage quiz before this
  // key existed still get the prefill.
  try {
    return fresh(JSON.parse(localStorage.getItem(QUIZ_KEY)));
  } catch (e) {
    return '';
  }
}
